module.exports = {
      id: "prothomalo-com-usage",
      viewBox: "0 0 200 27",
      url: "/" + "svg-sprite-475344759687326ca60b708b4aa20d33.svg#prothomalo-com",
      toString: function () {
        return this.url;
      }
    }